import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c8a704c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "joinUs_wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "joinUs_con"
}
const _hoisted_3 = { class: "joinUs_top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "共同创建一个公平公正的社会", -1))
const _hoisted_6 = { class: "joinUs_btm" }
const _hoisted_7 = { class: "lawyer_pW" }
const _hoisted_8 = { class: "lawyer_p1" }
const _hoisted_9 = { class: "lawyer_p2" }
const _hoisted_10 = { class: "lawyer_p2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "job_info"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "joinUs_conPh"
}
const _hoisted_16 = { class: "joinUs_top" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "共同创建一个公平公正的社会", -1))
const _hoisted_19 = { class: "joinUs_btm" }
const _hoisted_20 = { class: "box" }
const _hoisted_21 = { class: "lawyer_pW" }
const _hoisted_22 = { class: "lawyer_p1" }
const _hoisted_23 = { class: "lawyer_p2" }
const _hoisted_24 = { class: "lawyer_p2" }
const _hoisted_25 = {
  key: 0,
  class: "job_info"
}
const _hoisted_26 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: require('@/assets/image/joinUs/join2.png')
            }, null, 8, _hoisted_4),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_swiper, {
              "slides-per-view": 3,
              "space-between": 35,
              navigation: {
            nextEl: '.swiper-button-next', //前进后退按钮
            prevEl: '.swiper-button-prev',
          },
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange,
              class: "lawyer_ul"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (item, index) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: index,
                    class: _normalizeClass(_ctx.selectdIndex == index ? 'li_select lawyer_li' : 'lawyer_li'),
                    onClick: ($event: any) => (_ctx.slideClick(index))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(item.job), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.address), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(item.peopleNum), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128)),
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            }, 8, ["navigation", "onSwiper", "onSlideChange"]),
            (_ctx.dataSource && _ctx.dataSource.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "info_text",
                    innerHTML: _ctx.dataSource[_ctx.selectdIndex].desc
                  }, null, 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              src: require('@/assets/image/joinUs/joinTitP.png')
            }, null, 8, _hoisted_17),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "aa",
                onTouchstart: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touch && _ctx.touch(...args)), ["stop"]))
              }, null, 32),
              (_ctx.dataSource && _ctx.dataSource.length)
                ? (_openBlock(), _createBlock(_component_el_carousel, {
                    key: 0,
                    autoplay: false,
                    type: "card",
                    arrow: "never",
                    "indicator-position": "none",
                    onChange: _ctx.carouselChange,
                    height: "2.6rem",
                    ref: "carousel"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource.length, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, {
                          class: "lawyer_li",
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.dataSource[index] ? _ctx.dataSource[index].job : ""), 1),
                              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.dataSource[index] ? _ctx.dataSource[index].address : ""), 1),
                              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.dataSource[index] ? _ctx.dataSource[index].peopleNum : ""), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["onChange"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.dataSource && _ctx.dataSource.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: "info_text",
                    innerHTML: _ctx.dataSource[_ctx.selectdIndex].desc
                  }, null, 8, _hoisted_26)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}